import { Navigate } from "react-router-dom";
import { checkUserHasAdminRole } from "app/services/app.state.service";
import { UsageAnalyticsView } from "app/components/usage-analytics/UsageAnalyticsView";

/**
 * Route factory for the ADMIN-only Usage Analytics screen (HRMS-322). Client-side UX only: the
 * server refuses the summary to anyone but an admin.
 *
 * @since NEXT_VERSION
 */
export const UsageAnalyticsRouterFactory = () => {
  if (!checkUserHasAdminRole()) {
    return <Navigate to="/login" replace />;
  }
  return <UsageAnalyticsView />;
};
